<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Donation Amount">
                    <FormRow inline>      
                      <LazyCurrencySelector :currencies="['USD', 'ILS', 'CAD']"/> 
                    </FormRow>
                    <FormRow> 
                      <AmountSelector/>                    
                      <ErrorLabel field="amount" />
                    </FormRow>
                    <FormRow>
                      <PaymentOptions addSplit addMonthly monthesSelector/>
                    </FormRow>
                    <FormRow>
                        <Receipt :receipts="['us', 'israel', 'canadian']" />
                    </FormRow>
                </FormSection>
                <FormSection title="Donation Designation">
                  <NcsyIsraelDesignation />
                  <FormRow>
                    <FormLabel class="control-label"> Notes </FormLabel>
                  </FormRow>
                  <FormRow>
                    <FormInput type="textarea" field="custom.Notes" />
                  </FormRow>
                </FormSection>
                <FormSection title="Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                           
                </FormSection>
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton />
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep .radio-inline {
  margin-left: 20px !important;
}
</style>

